// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ExpertiseBadge_wrapper__3tIHD","selected":"ExpertiseBadge_selected__34TDi","icon":"ExpertiseBadge_icon__2p8GL"};